import {initBlogList} from "../swiper/swiper";

const classPrefix = 'main-blog'
const dataPrefix = 'data-main-blog'
const $container = document.querySelector(`[${dataPrefix}]`)
if ($container)
{
    mainBlog()
}
export function mainBlog() {


    initBlogList(`${classPrefix}__container-swiper`)

}
